// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"modal-element_backdrop__11kEw","scrollContainer":"modal-element_scrollContainer__gvFfO","modal":"modal-element_modal__7SieT"};